import lng from '@lightningjs/core';
import { Column } from '@lightningjs/ui-components';
import SettingsMenuItem from './SettingsMenuItem';

const settingsList = [
  {
    id: 1,
    title: 'Audio & Subtitles',
    icon: '/images/settings-icons/audio.svg',
    iconWidth: 38,
    path: 'settings/audio-subtitles',
  },
  {
    id: 2,
    title: 'My Account',
    icon: '/images/settings-icons/account.svg',
    iconWidth: 34,
    path: 'settings/my-account',
  },
  {
    id: 3,
    title: 'Filters',
    icon: '/images/settings-icons/filters.svg',
    iconWidth: 38,
    path: 'settings/filters',
  },
  {
    id: 4,
    title: 'Support',
    icon: '/images/settings-icons/support.svg',
    iconWidth: 27,
    path: 'settings/support',
  },
  {
    id: 5,
    title: 'Exit',
    icon: '/images/settings-icons/log-out.svg',
    iconWidth: 38,
    path: 'settings/exit',
  },
  {
    id: 6,
    title: 'Sign Out',
    icon: '/images/settings-icons/sign-out.svg',
    iconWidth: 37,
    path: 'settings/sign-out',
  },
];

export default class SettingsMenu extends lng.Component {
  static _template() {
    return {
      Column: {
        collision: true,
        type: Column,
        items: settingsList.map((item, index) => ({
          type: SettingsMenuItem,
          item,
          h: 75,
          w: 585,
          index,
        })),
      },
    };
  }
  get _Column() {
    return this.tag('Column');
  }

  _getFocused() {
    return this._Column;
  }

  $setIndex(index) {
    this._Column.selectedIndex = index;
  }
}
